export const QuickInformationTypes = [
  { id: 'quiz', name: 'Тест жагсаалт' },
  { id: 'post', name: 'Нийтлэл жагсаалт' },
  { id: 'scholarship', name: 'Тэтгэлэг жагсаалт' },
  { id: 'university', name: 'Их сургууль жагсаалт' },
];
